import { Field, Form as FormFormik, Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { FiMail, FiUserCheck, FiCreditCard } from 'react-icons/fi';
import { TbLicense } from 'react-icons/tb';
import { useDispatch, useSelector } from 'react-redux';
import {
  editMatriculado,
  getMatriculados,
  setEditModalId
} from 'redux/matriculadosSlice';
import { userMatriculadoEditSchema } from '../validations/matriculadoEditSchema';
import MyButtonSpinner from 'components/common/my-components/MyButtonSpinner';

export const EditMatriculadoForm = () => {
  const dispatch = useDispatch();
  const [loadingButton, setLoadingButton] = useState(false);
  const editModalId = useSelector(state => state.matriculados.editModalId);
  const matriculados = useSelector(state => state.matriculados.data);
  const matriculado = matriculados.find(
    matriculado => matriculado.id === editModalId
  );
  const page = useSelector(state => state.matriculados.page);
  const filtersAndSort = useSelector(
    state => state.matriculados.filtersAndSort
  );
  const propsLimit = useSelector(state => state.matriculados.propsLimit);
  const searchProp = useSelector(state => state.matriculados.searchProp);

  const handleSubmit = async values => {
    if (loadingButton) {
      return null;
    } else {
      setLoadingButton(true);

      const userData = {
        nombre: values.nombre,
        apellido: values.apellido,
        email: values.email,
        dni: values.dni,
        matricula: values.matricula
      };

      const response = dispatch(editMatriculado(editModalId, userData));
      if (response && response.status < 400) {
        setEditModalId(null);
        dispatch(getMatriculados(filtersAndSort, page, propsLimit, searchProp));
      }
    }
    setLoadingButton(false);
  };

  return (
    <Formik
      initialValues={{
        nombre: matriculado?.firstName || '',
        apellido: matriculado?.lastName || '',
        email: matriculado?.email || '',
        dni: matriculado?.dni || '',
        matricula: matriculado?.matricula || ''
      }}
      validationSchema={userMatriculadoEditSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched }) => (
        <FormFormik>
          <Row className="g-3">
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>
                  <FiUserCheck /> Nombre
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="nombre"
                  type="text"
                  placeholder="Ingresa un nombre"
                  isInvalid={errors.nombre && touched.nombre}
                />
                {errors.nombre && touched.nombre && (
                  <p className="text-danger small m-0">{errors.nombre}</p>
                )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>
                  <FiUserCheck /> Apellido
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="apellido"
                  type="text"
                  placeholder="Ingresa un apellido"
                  isInvalid={errors.apellido && touched.apellido}
                />
                {errors.apellido && touched.apellido && (
                  <p className="text-danger small m-0">{errors.apellido}</p>
                )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>
                  <FiCreditCard /> DNI
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="dni"
                  type="text"
                  placeholder="Ingresa un DNI"
                  isInvalid={errors.dni && touched.dni}
                />
                {errors.dni && touched.dni && (
                  <p className="text-danger small m-0">{errors.dni}</p>
                )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>
                  <TbLicense /> Matrícula
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="matricula"
                  type="number"
                  placeholder="Ingresa la matrícula"
                  isInvalid={errors.matricula && touched.matricula}
                />
                {errors.matricula && touched.matricula && (
                  <p className="text-danger small m-0">{errors.matricula}</p>
                )}
              </Form.Group>
            </Col>

            <Col xs={12}>
              <Form.Group>
                <Form.Label>
                  <FiMail /> Email
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="email"
                  type="email"
                  placeholder="Ingresa un email"
                  isInvalid={errors.email && touched.email}
                />
                {errors.email && touched.email && (
                  <p className="text-danger small m-0">{errors.email}</p>
                )}
              </Form.Group>
            </Col>

            <Col xs={12}>
              {!loadingButton ? (
                <Button
                  variant="primary"
                  type="submit"
                  className="w-100"
                  disabled={
                    !!errors.nombre ||
                    !!errors.apellido ||
                    !!errors.email ||
                    !!errors.dni ||
                    !!errors.matricula ||
                    loadingButton
                  }
                >
                  Editar Matriculado
                </Button>
              ) : (
                <MyButtonSpinner className="w-100" />
              )}
            </Col>
          </Row>
        </FormFormik>
      )}
    </Formik>
  );
};

EditMatriculadoForm.propTypes = {
  editModalId: PropTypes.string
};
